/**
 * Labstep
 *
 * @module components/ProtocolValue/Variable/Detail
 * @desc ProtocolValue Variable Detail
 */

import { ProtocolConditionProtocolValueVariableSmartTable } from 'labstep-web/components/ProtocolCondition/ProtocolValueVariableSmartTable';
import { ProtocolValueVariableActionContainer } from 'labstep-web/components/ProtocolValue/Variable/Action/Container';
import { GridSmartTableProtocolConditionService } from 'labstep-web/grid/SmartTableProtocolCondition/services/grid-smart-table-protocol-condition.service';
import { Protocol } from 'labstep-web/models/protocol.model';
import type React from 'react';
import type { GridProtocolValueVariableProps } from './types';

export const ProtocolValueVariableDetail: React.FC<
  GridProtocolValueVariableProps
> = ({ protocol, protocolValue, read }) => {
  return protocol.n_protocol_conditions ||
    protocol instanceof Protocol ||
    protocolValue.is_output ? (
    <ProtocolConditionProtocolValueVariableSmartTable
      protocol={protocol}
      variableTemplate={protocolValue}
      defaultColIds={GridSmartTableProtocolConditionService.getDefaultProtocolValueVariableColIds(
        protocolValue,
      )}
      name={'Conditions Table'}
    />
  ) : (
    <ProtocolValueVariableActionContainer
      protocolValue={protocolValue}
    />
  );
};
